import { render, staticRenderFns } from "./AllocatedProjectItem.vue?vue&type=template&id=6bce4723&scoped=true&"
import script from "./AllocatedProjectItem.vue?vue&type=script&lang=js&"
export * from "./AllocatedProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedProjectItem.vue?vue&type=style&index=0&id=6bce4723&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce4723",
  null
  
)

export default component.exports